import { mapDTO } from '@twistezo/ts-dto-mapper'

import type { DomainRichPlacementInterstitial } from '../../types/domainRichPlacementInterstitial'
import type { DomainRichPlacementInterstitialConfigurationDTO } from '../types/domainRichPlacementInterstitialConfigurationDTO'

type From = DomainRichPlacementInterstitialConfigurationDTO
type To = DomainRichPlacementInterstitial

export const domainRichPlacementInterstitialFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const {
      availability,
      customVariableName,
      customVariableTriggerEnabled,
      customVariableValue,
      enabled,
      matchType,
      path,
      pathTriggerEnabled,
    } = data

    return {
      availability: availability ?? undefined,
      customVariableName: customVariableName ?? undefined,
      customVariableTriggerEnabled,
      customVariableValue: customVariableValue ?? undefined,
      enabled,
      matchType,
      path: path ?? undefined,
      pathTriggerEnabled,
    }
  })
